import { handleActions } from "redux-actions";

import {
  UPDATE_DATE,
  UPDATE_REVENUE_TYPE_SUCCESS,
  SET_REVENUE_TYPE_LOADING,
  FETCH_REVENUE_TYPE_FILTER_SUCCESS
} from "./dashboardFiltersSaga";

export const initialState = {
  date: null,
  revenueTypeInitRequest: false,
  isRevenueTypeLoading: false,
  showRevenueTypeFilter: false,
  revenue_type: {},
  revenueTypeOptions: [
    { id: "gross", name: "Gross" },
    { id: "net", name: "Net" }
  ]
};

const findRevenueType = (state, revenueTypeId) =>
  state.revenueTypeOptions.find((type) => type.id === revenueTypeId);

export default handleActions(
  {
    [SET_REVENUE_TYPE_LOADING]: (state, action) => ({
      ...state,
      isRevenueTypeLoading: action.payload
    }),
    [UPDATE_DATE]: (state, action) => ({
      ...state,
      date: action.payload
    }),
    [UPDATE_REVENUE_TYPE_SUCCESS]: (state, action) => ({
      ...state,
      revenue_type: findRevenueType(state, action.payload.revenue_type)
    }),
    [FETCH_REVENUE_TYPE_FILTER_SUCCESS]: (state, action) => ({
      ...state,
      revenue_type: findRevenueType(state, action.payload.revenue_type),
      revenueTypeInitRequest: true
    })
  },
  initialState
);
